import bannerBg from '../images/banner_bg.jpg';
import bannerBottom from '../images/banner_bottom.jpg';
import laptopScreen from '../images/laptop_screen.jpg';
import ring from '../images/ring.png';
import steps from '../images/steps.png';
import whyChooseIcons from '../images/icons.png';

export const DISRUPTIONS = [
  { rank: '1', suffix: 'st', tone: 'blue', icon: 'fa-desktop', title: 'Unplanned IT and telecom outages' },
  { rank: '2', suffix: 'nd', tone: 'dark-blue', icon: 'fa-medkit', title: 'Health and safety incident' },
  { rank: '3', suffix: 'rd', tone: 'yellow', icon: 'fa-users', title: 'Lack of talent/Key skills' },
  { rank: '4', suffix: 'th', tone: 'red', icon: 'fa-shield', title: 'Cyber attack' },
  { rank: '5', suffix: 'th', tone: 'green', icon: 'fa-arrow-circle-left', title: 'Product recall' },
  { rank: '6', suffix: 'th', tone: 'blue', icon: 'fa-snowflake-o', title: 'Adverse weather/natural disaster' },
  { rank: '7', suffix: 'th', tone: 'dark-blue', icon: 'fa-money', title: 'Exchange rate volatility' },
  { rank: '8', suffix: 'th', tone: 'yellow', icon: 'fa-globe', title: 'Natural resources shortage' },
  { rank: '9', suffix: 'th', tone: 'red', icon: 'fa-file-text', title: 'Regulatory changes' },
  { rank: '10', suffix: 'th', tone: 'green', icon: 'fa-line-chart', title: 'Higher cost of borrowing' },
];

export default {
  disruptions: DISRUPTIONS,
  videoSrc: 'https://www.youtube.com/embed/U-EoStHt4-g?rel=0&showinfo=0',
  newsUrl: 'https://lmigroup.io/news/',
  images: {
    bannerBg,
    bannerBottom,
    ring,
    steps,
    screens: laptopScreen,
    whyChooseIcons,
  },
  copy: {
    // Stacked h2 + h1 (or h1 lines + h2) are one phrase; only the first word is capped
    // unless a later word is a proper noun (e.g. ContinuityCoach).
    heroHeading: {
      titleLines: ['What threats', 'to your business'],
      kicker: 'KEEP YOU AWAKE AT NIGHT?',
    },
    heroSlogan: 'Let the LMI ContinuityCoach assist you in identifying your risk and planning your recovery.',
    bcmHeading: {
      kicker: 'What is Business',
      title: 'Continuity Management',
    },
    bcmLead:
      'Business Continuity enables you to identify potential threats and their impacts to your business operations.',
    bcmClose:
      'With the ability that comes from a defined strategy, the pro-active management of these threats allows your organisation to protect and continue the value-creating operations in the event of disruption.',
    whyHeading: {
      kicker: 'Why choose',
      title: 'ContinuityCoach?',
    },
    whyLead:
      'With ContinuityCoach you have world class experts in business continuity management planning and crisis recovery experts coaching you through every step of the process.',
    whyRequirement:
      'Business Continuity Institute Good Practice Guidelines & International Organization for Standardization ISO 22301 Societal Security',
    whyRequirementAfter: '--- Business Continuity Management Systems --- Requirements.',
    whyItems: [
      {
        title: 'VISUALISE',
        body: 'Identifying and visualising the many aspects of risk that may affect your business',
      },
      {
        title: 'UNDERSTAND',
        body: 'Delivering a broad understanding of your organisational threats and its business imperatives',
      },
      { title: 'IMPROVE', body: 'Identifying opportunities to improve operational processes' },
      { title: 'PLAN', body: 'Providing plans to recover your crisis AREAS' },
      { title: 'TEST', body: 'Scenarios and testing levels for self-evaluation' },
    ],
    recoverHeading: {
      kicker: 'The most advanced way to',
      title: 'help your business recover from a crisis',
    },
    recoverLead:
      "LMI ContinuityCoach is modelled on International Organization for Standardization ISO 22301 standards and the Business Continuity Institute ('BCI') Good Practice Guidelines (GPG: 2013/2018). It is designed to be an easy-to-use, cost effective and highly available Web-based Continuity tool.",
    recoverClose:
      "Whilst recovery rates vary, what is undeniable is that a Business Continuity Management Plan ('BCP') can:",
    benefits: [
      'help improve the chance of survival',
      'make your business more attractive to Insurers',
      'reduce downtime',
      'opportunistically improve efficiency and costs',
      'provide a competitive advantage',
    ],
    ctaHeading: {
      kicker: 'Gain a better understanding of the risks facing your business',
      title: 'FAST. SECURE. EASY',
    },
    newsTitle: 'Latest News',
    newsCta: 'More News',
    disruptionsHeading: {
      kicker: 'Top 10 global',
      title: 'disruptions',
    },
    disruptionsCaption: 'Top ten disruptions - past twelve months. Courtesy of the BCI Horizon Scan Report 2019.',
  },
  disruptionColors: {
    blue: '#5bc2e7',
    darkBlue: '#343579',
    yellow: '#f1c400',
    red: '#cb2c30',
    green: '#00685e',
  },
  surfaces: {
    accent: '#f1c400',
  },
  flags: {
    sentenceCase: false,
    citeRequirement: false,
    unifiedBenefitAccent: false,
  },
};
